import { useQueryClient } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";

import { Footer } from "../components/ui/navigation/Footer";
import { Sidebar } from "../components/ui/navigation/Sidebar";
import { Topbar } from "../components/ui/navigation/Topbar";
import { useSession } from "../app/session/SessionProvider";
import { logout } from "../features/auth/api/authApi";

interface AppShellProps extends PropsWithChildren {
  title: string;
  breadcrumb: readonly string[];
}

export function AppShell({ title, children }: AppShellProps) {
  const { member } = useSession();
  const queryClient = useQueryClient();
  const handleLogout = async () => {
    await logout();
    queryClient.setQueryData(["session"], null);
  };
  return (
    <>
      <a className="skip-link" href="#main-content">跳至主要內容</a>
      <div id="wrapper">
        {member && <Sidebar role={member.role} />}
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar memberName={member?.registrantName ?? ""} onLogout={handleLogout} />
            <main id="main-content" className="container-fluid" tabIndex={-1}>
              <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">{title}</h1>
              </div>
              {children}
            </main>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

